import { MenuItem } from "@kaltura/ds-react-components";
import { useState } from "react";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { InviteModal, InviteProps } from "./InviteModal";
import { ButtonAnalyticsProvider, useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";

/**
 * Invite external user menu item for media-page in title area actions menu
 */
export const InviteMenuItem = (props: InviteProps) => {
    const { autoFocus, onCloseMenu, ...modalProps } = props;

    const [isOpen, setIsOpen] = useState(false);
    const sendButtonAnalytics = useButtonAnalytics();

    const openModal = () => {
        setIsOpen(true);
        sendButtonAnalytics(
            "Invite user - open modal",
            ButtonClickAnalyticsType.OPEN,
            props.entryId,
            "invitetomedia",
            "Entry page / media owner view"
        );
    };

    const closeModal = () => {
        setIsOpen(false);
        onCloseMenu?.();
    };

    return (
        <>
            <MenuItem onClick={openModal} autoFocus={autoFocus}>
                {translate("Invite Users")}
            </MenuItem>
            <ButtonAnalyticsProvider applicationFeature={"invitetomedia"} location={"Invitation modal"}>
                {isOpen && <InviteModal {...modalProps} onClose={closeModal} />}
            </ButtonAnalyticsProvider>
        </>
    );
};
